# Indie blogs, essays & the small web
https://paulgraham.com
https://slatestarcodex.com
https://astralcodexten.substack.com
https://waitbutwhy.com
https://fs.blog
https://ribbonfarm.com
https://kk.org/thetechnium
https://collaborativefund.com/blog
https://jamesclear.com
https://markmanson.net
https://calnewport.com
https://nesslabs.com
https://patrickcollison.com
https://stratechery.com
https://daringfireball.net
https://kottke.org
https://boingboing.net
https://jacobin.com
https://currentaffairs.org
https://gwern.net
https://sive.rs
https://tedium.co
https://readmargins.com
https://neocities.org
https://tildeverse.org
https://tilde.club
https://tilde.team
https://tilde.town
https://indieweb.org
https://indieweb.org/IndieWebCamps
https://512pixels.net
https://macstories.net
https://sixcolors.com
https://dithering.fm
https://hypercritical.co
https://taptanium.com
https://marco.org
https://inessential.com
https://mjtsai.com
https://daringfireball.net
https://leancrew.com
https://candlerblog.com
https://512px.net
https://birchtree.me
https://beautifulpixels.com
https://thesweetsetup.com
https://macsparky.com
https://cortexfutura.com
https://fortelabs.com
https://zettelkasten.de
https://takesmartnotes.com
https://writingcooperative.com
https://every.to
https://notboring.co
https://theprofile.co
https://platformer.news
https://onezero.medium.com
https://future.com
https://slowboring.com
https://doomberg.substack.com
https://marginalrevolution.com
https://overcomingbias.com
https://jakeseliger.com
https://tylercowen.com
https://kylerego.net
https://brr.fyi
https://antipope.org
https://crookedtimber.org
https://languagelog.ldc.upenn.edu
https://streetlifesolutions.blogspot.com
https://walkablestreets.wordpress.com
https://thetransitguy.com
https://urbanophile.com
https://strongtowns.org
https://lowtechmagazine.com
https://solar.lowtechmagazine.com
https://noemamag.com
https://hedgehogreview.com
https://thepointmag.com
https://nplusonemag.com
https://thebaffler.com
https://logicmag.io
https://reallifemag.com
https://thenewinquiry.com
https://cryptonews.com.au
